import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import OverlayStack from '@/components/Overlay/OverlayStack';
// Keyhole nav removed: render content directly without NavigationContainer/Overlay
import { NavigationProvider } from '@/context/NavigationContext';
import ImagePreloader from '@/components/ImagePreloader';
import SiteFrame from './SiteFrame';

const App: FC = () => {
  const location = useLocation();

  // Overlay stack managed in OverlayStack component
  const [themeMounted, setThemeMounted] = useState(false);

  useEffect(() => {
    setThemeMounted(true);
  }, []);

  if (!themeMounted) return null;

  return (
    <NavigationProvider pathname={location.pathname} location={location}>
      <ImagePreloader />
      <SiteFrame>
        {/* Overlay stack renders independently so exit animations play when dismissing */}
        <OverlayStack />
      </SiteFrame>
    </NavigationProvider>
  );
};

export default App;
